import { emitJson } from '#@/format/json.ts'
import { emitPretty, plainStyle } from '#@/format/pretty.ts'
import type { Runtime } from '#@/runtime/Runtime.ts'

/**
 * Browser bundles. No `process` read: an entry that needs another level calls `configureLogger` (AD5). Tags render as
 * `[name]`, so one copied console line keeps the prefixes and the fields as text.
 */
export const defaults: Runtime['defaults'] = () => ({ level: 'debug', format: 'pretty' })

export const readConfig: Runtime['readConfig'] = () => ({ level: undefined, format: undefined })

export const emit: Runtime['emit'] = (entry) => {
  if (entry.format === 'json') {
    emitJson(entry.level, entry.record)
  } else {
    emitPretty({ ...entry, style: plainStyle })
  }
}
